import styled from "@emotion/styled";
import { colors } from "ui";

const Wrapper = styled.div`
  position: relative;
  margin-top: 150px;
  text-align: center;

  h1 {
    z-index: 1;
    font-weight: 500;
    margin-bottom: 10px;
    padding-top: 50px;
    color: ${colors.white};
    width: 100%;
  }
`;

const BackgroundPlate = styled.div`
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 1;
  height: 100%;
  width: 100vw;
  background: ${colors.pink400};
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Sections = styled.div<{ $reverse?: boolean }>`
  z-index: 1;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  padding: 20px 0;

  @media (min-width: 650px) {
    flex-direction: ${({ $reverse }) => ($reverse ? "row-reverse" : "row")};
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1;
  width: 100%;
  padding: 20px;
  color: white;

  p {
    letter-spacing: 1.25px;
    line-height: 1.25;
  }

  button {
    margin-top: 20px;
  }

  svg {
    max-width: 350px;
  }

  @media (min-width: 650px) {
    width: 50%;
  }
`;

type Props = {
  title?: string;
  img: any;
  content: any;
  reverse?: boolean;
};

const USP = ({ title, img, content, reverse }: Props) => {
  return (
    <Wrapper>
      <BackgroundPlate />
      <Column>
        {title && <h1>{title}</h1>}
        <Sections $reverse={reverse}>
          <Section>{img}</Section>
          <Section>{content}</Section>
        </Sections>
      </Column>
    </Wrapper>
  );
};

export default USP;
